/** @module csi/table/SlimPreferences */
define([
	"dojo/_base/declare",
	"csi/constants",
	"csi/table/Preferences"
], function(declare,constants,Preferences) {

	return declare(Preferences, {
		customOptions: [
			{name: "fixedColumnWidths", value: {}},
			{name: "sortSettings", personalized: true, value: []},
			{name: "tableFreezeColumns", formerName: "TableFreeze", personalized: true, value: constants.TABLE_DEFAULT_FREEZE_COLUMNS},
		],
	});
});